/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { Redirect, Switch } from 'react-router';
import { PrivateRoute } from 'src/core/components/PrivateRoute';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { routeTable } from 'src/core/utils/routeTable';
import { LuisAppSettingsPage } from 'src/luis/appShell/managePane/appSettingsPage/LuisAppSettingsPage';
import { AppVersionsPage } from 'src/luis/appShell/managePane/appVersionsPage/AppVersionsPage';
import { AzureCsAccountsPage } from 'src/luis/appShell/managePane/azureAccountsPage/AzureCsAccountsPage';
import { PublishSettingsPage } from 'src/luis/appShell/managePane/publishSettingsPage/PublishSettingsPage';

/**
 * Renders the routes for the manage pane.
 *
 * @todo Separate for conversations and documents.
 */
export const ManagePane = () => {
    const { rootStore } = useGlobalState();

    return (
        <Switch>
            <PrivateRoute path={[routeTable.luis.applicationInfoPage()]} component={LuisAppSettingsPage} />
            <PrivateRoute path={[routeTable.luis.azureResourcesPage()]} component={AzureCsAccountsPage} />
            <PrivateRoute path={[routeTable.luis.publishSettingsPage()]} component={PublishSettingsPage} />
            <PrivateRoute path={routeTable.luis.versionsPage()} component={AppVersionsPage} />
            <Redirect to={routeTable.luis.applicationInfoPage(rootStore.currentLuisAppStore.id, '0.1')} />
        </Switch>
    );
};
